exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".about,.construction{width:90%;margin:auto}.about h2,.construction h2{font-family:Black Ops One,cursive}.about li,.about p,.construction li,.construction p{font-size:1.3em;font-family:Roboto,sans-serif}@media (min-width:700px){.about{max-width:670px;margin:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./styles/modules/about.scss
// module id = 297
// module chunks = 0